import React, { useState, useEffect } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const BarChart = (props) => {
  const { labels, happyData, normalData, sadData } = props;

  const options = {
    scales: {
      y: {
        title: { display: true, text: "Count" },
      },
      x: {
        title: {
          display: true,
          text: "Time",
        },
      },
    },
    indexAxis: "x",
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
      },
      title: {
        display: true,
        text: "Hourly Average",
      },
    },
  };

  const data = {
    labels,
    datasets: [
      {
        label: "Happy",
        data: happyData,
        borderColor: "#226BF6",
        backgroundColor: "#226BF6",
      },
      {
        label: "Normal",
        data: normalData,
        borderColor: "#FBCD57",
        backgroundColor: "#FBCD57",
      },
      {
        label: "Sad",
        data: sadData,
        borderColor: "#FF5F49",
        backgroundColor: "#FF5F49",
      },
    ],
  };

  return <Bar height={70} width={200} options={options} data={data} />;
};

export default BarChart;
